module.exports = __webpack_public_path__ + "static/media/search.03f0157d.svg";